<template>
	<div>
		<nav class="navbar-menu default-layout col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
			<div class="logo">
				<ul>
					<li><img src="../../static/images/logo.png" class="topLogo"/> </li>
					<li> <img src="../../static/images/systemName.png" class="systemNameimg"/></li>
				</ul>
			</div>
			
			<div class="navbar-menu-wrapper d-flex align-items-center">
				<ul>
					<li class="nav-item dropdown ">
						<a
							class="nav-link dropdown-toggle"
							id="UserDropdown"
							href="#"
							data-toggle="dropdown"
							aria-expanded="true"
						>
<!--							<img class="img-xs rounded-circle" src="../images/face1.jpg" alt="Profile image">-->
							<span class>{{name1}}</span>
						</a>
						<ul class="dropdown-menu user-menu" role="menu" aria-labelledby="UserDropdown">
					        <li role="presentation" @click="showpwd">
					            <span role="menuitem" tabindex="-1">修改密码</span>
					        </li>
					        <li role="presentation"  @click="toPage('/editStaff.do',userId1)">
					            <span role="menuitem" tabindex="-1">基本信息</span>
					        </li>
					        <li role="presentation" class="divider"></li>
							<li role="presentation" class="dropdown-header">版本：{{systemVersion}}</li>
					    </ul>
					</li>
					<!--系统消息-->
					<li class="nav-item dropdown ">
						<a
							class="nav-link count-indicator"
							id="notificationDropdown"
							href="#"
							title="消息中心"
							data-toggle="dropdown"
						>
							<i class="mdi mdi-bell"></i>
							<span class="count" v-if="allMessageNum1>0">{{allMessageNum1}}</span>
						</a>
						<ul class="dropdown-menu message-menu" role="menu" aria-labelledby="notificationDropdown">
					        <li role="presentation" class="dropdown-header">消息中心</li>
					        <li role="presentation" class="divider"></li>
					        <li class="row" role="presentation" @click="toPage('/messageList.do', '')">
					            <span role="menuitem" tabindex="-1">全部消息</span>
					            <span class="red" role="menuitem" tabindex="-1">({{allMessageNum1}})</span>
					        </li>
					        <li class="row" role="presentation" @click="toPage('/messageList.do', '1')">
					            <span role="menuitem" tabindex="-1">未读消息</span>
					            <span class="red" role="menuitem" tabindex="-1">({{unreadMessageNum1}})</span>
					        </li>
					        <li class="row" role="presentation" @click="toPage('/messageList.do', '2')">
					            <span role="menuitem" tabindex="-1">商户消息</span>
					            <span class="red" role="menuitem" tabindex="-1">({{userMessageNum1}})</span>
					        </li>
					    </ul>
					</li>
					<!--账户设置-->
					<li class="nav-item dropdown" @click="toPage('/editStaff.do',userId1)">
						<a
							class="nav-link count-indicator"
							id="messageDropdown"
							href="#"
							title="账户设置"
						>
							<i class="mdi mdi-settings"></i>
						</a>
					</li>
					<!--退出登录-->
					<li class="nav-item dropdown" @click="logout">
						<a
							class="nav-link count-indicator"
							id="messageDropdown"
							href="#"
							title="退出登录"
						>
							<i class="fa fa-power-off"></i>
						</a>
					</li>
				</ul>
			</div>
		</nav>
		<logout></logout>
		<div id="changePwd">
			<form>
				<div class="row m-top-10">
                  <label class="col-sm-3 col-form-label text-right"><span class="red">*</span>输入旧密码</label>
                  <div class="col-sm-6">
                    <input type="password" class="form-control" placeholder="请输入旧密码" v-model="oldPassword" autocomplete="off">
                  </div>
              </div>
              <div class="row m-top-10">
                  <label class="col-sm-3 col-form-label text-right"><span class="red">*</span>请输入新密码 </label>
                  <div class="col-sm-6">
                    <input type="password" class="form-control" placeholder="请输入新密码" v-model="newPassword" autocomplete="off">
                  </div>
              </div>
               <div class="row m-top-10">
                  <label class="col-sm-3 col-form-label text-right"><span class="red">*</span>请确认新密码 </label>
                  <div class="col-sm-6">
                    <input type="password" class="form-control" placeholder="请输入确认新密码" v-model="newPassword1" autocomplete="off">
                  </div>
              </div>
                <div class=" m-top-10 text-center hr">
              	<button class="btn cancelBtn " @click="cancel">取消</button><button class="btn okBtn" @click="update">确定</button>
              </div>
              </form>
		</div>
	</div>
</template>

<script>
import logout from './logoutPop-up'
import {utils,openlayer,closelayer,confirm} from '../utils/utils'
import {get,post} from '../utils/request'
export default {
	data() {
		return{
			oldPassword:"",
			newPassword:"",
			newPassword1:"",
			name1:this.name,
			allMessageNum1:this.allMessageNum,
			unreadMessageNum1:this.unreadMessageNum,
			userMessageNum1:this.userMessageNum,
			userId1:this.userId,
			systemName:'巡检系统',
			sysIcon:'检',
			systemVersion:sessionStorage.getItem("systemVersion")?sessionStorage.getItem("systemVersion"):''
		}
	},
	mounted() {
		
	},
	components: {
		logout
	},
	props: ['name','allMessageNum','unreadMessageNum','userMessageNum',"userId"],
	methods: {
		getver(){//获取系统信息
				post('/user/systemInfo', '').then((data) => {
					console.log(data.data.systemVersion+"-----------");
					this.systemVersion=data.data.systemVersion;
					this.systemName= data.data.systemName;
					this.sysIcon= data.data.sysIcon;
					sessionStorage.setItem("systemVersion",data.data.systemVersion)
				})
			},
		init(){
		this.allMessageNum1 = sessionStorage.getItem("allMessageNum");
		this.unreadMessageNum1 = sessionStorage.getItem("unreadMessageNum");
		this.userMessageNum1 = sessionStorage.getItem("userMessageNum");
		this.name1=sessionStorage.getItem("name");
		this.userId1=sessionStorage.getItem("userId");
		if(!sessionStorage.getItem("systemVersion")){
			this.getver();
		}
		
		},
		//页面之间传参数
			toPage(path, id) {
				this.$router.push({
					path: path,
					query: {
						id: id
					}
				})
			},
		logout(){
			openlayer({
				title:'确认提示',
				btn:[],
				area:['350px',"210px"],
				content:$("#logout")
			})
		},
		showpwd(){
			openlayer({
				title:'修改密码',
				btn:[],
				area:['700px',"335px"],
				content:$("#changePwd"),
				success:(index, layero)=>{
					
				}
			})
		},
		cancel(){
			closelayer();
		},
		update(){
			var param={
				oldPassword:this.oldPassword,
				newPassword:this.newPassword
			}
			if(this.oldPassword==""){
				layer.msg("请输入旧密码");
				return;
			}
			if(this.newPassword==""){
				layer.msg("请输入新密码");
				return;
			}
			if(this.newPassword1!=this.newPassword){
				layer.msg("两次密码不一致");
				return;
			}
				post('/user/modifyPassword', param).then((data)=>{
					if(data.errcode==200){
						layer.msg("修改成功");
						closelayer();
					}else{
						layer.msg(data.errmsg);
					}
				});
		}
	}
}
</script>

<style>
@import '../../static/css/header.css';
#changePwd{display: none;padding:2rem 2rem;}
#changePwd .red{color: red;}
#changePwd  .m-top-10{margin-top:10px;}

</style>


// WEBPACK FOOTER //
// src/components/header.vue